import React from 'react';
import { FileText, Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const AvisoPrivacidad = () => {
  const handleWhatsAppContact = () => {
    window.open('https://wa.me/5219841855185', '_blank');
  };

  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gradient-to-r from-notaria-primary to-notaria-secondary text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <FileText className="w-16 h-16 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Aviso de Privacidad
            </h1>
            <p className="text-xl">
              Notaría Pública 90 - Protección de Datos Personales
            </p>
          </div>
        </div>
      </section>

      {/* Información de Contacto */}
      <section className="py-8 bg-gray-50 border-b-2 border-notaria-secondary">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white p-6 rounded-lg shadow-md border-2 border-notaria-secondary">
              <div className="text-center mb-6">
                <img
                  src="https://notariapublica90.com/wp-content/uploads/2025/06/logo-light-notaria.png"
                  alt="Notaría 90 Logo"
                  className="h-20 mx-auto mb-4"
                />
                <h2 className="text-2xl font-bold text-notaria-primary mb-2">
                  Ricardo Dehesa Cortés - Notario Titular
                </h2>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                <div className="flex flex-col items-center gap-2">
                  <Phone className="w-5 h-5 text-notaria-secondary" />
                  <div>
                    <p className="text-sm text-notaria-gray">Teléfono:</p>
                    <a href="tel:+5299848030555" className="text-notaria-secondary font-semibold hover:underline">
                      +52 (984) 803 0555
                    </a>
                  </div>
                </div>
                
                <div className="flex flex-col items-center gap-2">
                  <Mail className="w-5 h-5 text-notaria-secondary" />
                  <div>
                    <p className="text-sm text-notaria-gray">Email:</p>
                    <a href="mailto:ricardodehesa@notariapublica90.com" className="text-notaria-secondary font-semibold hover:underline break-all">
                      ricardodehesa@notariapublica90.com
                    </a>
                  </div>
                </div>
                
                <div className="flex flex-col items-center gap-2">
                  <MapPin className="w-5 h-5 text-notaria-secondary" />
                  <div>
                    <p className="text-sm text-notaria-gray">Dirección:</p>
                    <p className="text-sm font-semibold">
                      5ta avenida con 42 norte, Edificio Tan-Ik, Mezzanine, Col. Zazil Ha, Playa del Carmen
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 text-center">
                <Button
                  onClick={handleWhatsAppContact}
                  className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 inline-flex items-center gap-2"
                >
                  <MessageCircle className="w-5 h-5" />
                  Contactar por WhatsApp
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contenido del Aviso */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto prose prose-lg">
            
            <div className="bg-notaria-secondary/10 border-l-4 border-notaria-secondary p-6 mb-8">
              <p className="text-notaria-primary font-semibold mb-0">
                En cumplimiento a lo dispuesto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, 
                el Notario Público número Noventa, en ejercicio en el Estado de Quintana Roo, con circunscripción territorial en 
                el Municipio de Solidaridad de esta Entidad Federativa, con domicilio ubicado en las calles Cuarenta y Cuarenta y 
                Dos Norte, oficina Mezzanine Cuatro, edificio Tanik, colonia Zazil Ha, de esta ciudad, les informa que los datos 
                obtenidos en virtud de la operación que ustedes están realizando con la Notaría serán usados únicamente para la 
                presente operación y registro de los servicios aquí prestados.
              </p>
            </div>

            <h2 className="text-3xl font-bold text-notaria-primary">Responsable de la Protección de Datos</h2>
            <p>
              La Notaría Pública 90, con domicilio en 5ta avenida con 42 norte, edificio Tan-Ik, piso Mezzanine, 
              Col. Zazil Ha, Playa del Carmen, Quintana Roo, es responsable del tratamiento de sus datos personales.
            </p>

            <h2 className="text-3xl font-bold text-notaria-primary">Datos Personales Recabados</h2>
            <p>
              Para las finalidades señaladas en el presente aviso de privacidad, podemos recabar sus datos personales 
              de distintas formas: cuando usted nos los proporciona directamente; cuando visita nuestro sitio de Internet 
              o utiliza nuestros servicios en línea, y cuando obtenemos información a través de otras fuentes que están 
              permitidas por la ley.
            </p>
            
            <p>Los datos personales que recabamos de forma directa incluyen:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Datos de identificación (nombre completo, fecha de nacimiento, RFC, CURP)</li>
              <li>Datos de contacto (domicilio, teléfono, correo electrónico)</li>
              <li>Datos laborales (ocupación, lugar de trabajo, ingresos)</li>
              <li>Datos patrimoniales y financieros</li>
              <li>Datos relacionados con el acto jurídico notarial que se pretende realizar</li>
            </ul>

            <h2 className="text-3xl font-bold text-notaria-primary">Finalidades del Tratamiento</h2>
            <p>
              Los datos personales que recabamos serán utilizados para las siguientes finalidades primarias y necesarias:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Elaboración de escrituras públicas y actas notariales</li>
              <li>Dar fe de hechos y actos jurídicos</li>
              <li>Realizar trámites ante autoridades gubernamentales</li>
              <li>Cumplir con obligaciones fiscales y legales</li>
              <li>Conformar y mantener el protocolo notarial</li>
              <li>Gestión administrativa y contable de la notaría</li>
            </ul>

            <p className="mt-4">
              De manera adicional, utilizaremos su información personal para las siguientes finalidades secundarias:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Envío de información sobre servicios notariales</li>
              <li>Atención de consultas y solicitudes</li>
              <li>Fines estadísticos y de mejora de servicios</li>
            </ul>

            <h2 className="text-3xl font-bold text-notaria-primary">Transferencia de Datos</h2>
            <p>
              Sus datos personales pueden ser transferidos y tratados dentro y fuera del país, por personas distintas 
              a esta notaría. En ese sentido, su información puede ser compartida con:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Autoridades competentes (Registro Público de la Propiedad, SAT, autoridades judiciales)</li>
              <li>Instituciones financieras y bancarias</li>
              <li>Otras notarías para asuntos relacionados</li>
              <li>Proveedores de servicios notariales auxiliares</li>
            </ul>

            <h2 className="text-3xl font-bold text-notaria-primary">Derechos ARCO</h2>
            <p>
              Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las 
              condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su 
              información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); 
              que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo 
              utilizada conforme a los principios, deberes y obligaciones previstas en la normativa (Cancelación); 
              así como oponerse al uso de sus datos personales para fines específicos (Oposición).
            </p>

            <p>
              Para el ejercicio de cualquiera de los derechos ARCO, usted deberá presentar la solicitud respectiva 
              a través del siguiente medio:
            </p>
            <p className="font-semibold text-notaria-secondary">
              Correo electrónico: ricardodehesa@notariapublica90.com<br />
              Teléfono: +52 (984) 803 0555
            </p>

            <h2 className="text-3xl font-bold text-notaria-primary">Revocación del Consentimiento</h2>
            <p>
              Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus 
              datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos 
              atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación 
              legal requiramos seguir tratando sus datos personales.
            </p>

            <h2 className="text-3xl font-bold text-notaria-primary">Limitación de Uso y Divulgación</h2>
            <p>
              Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos 
              los siguientes medios:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Su inscripción en el Registro Público para Evitar Publicidad (REPEP)</li>
              <li>Su registro directo ante esta notaría en el correo electrónico señalado anteriormente</li>
            </ul>

            <h2 className="text-3xl font-bold text-notaria-primary">Modificaciones al Aviso de Privacidad</h2>
            <p>
              Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones al presente 
              aviso de privacidad, para la atención de novedades legislativas, políticas internas o nuevos requerimientos 
              para la prestación u ofrecimiento de nuestros servicios o productos.
            </p>

            <p>
              Estas modificaciones estarán disponibles al público a través de los siguientes medios:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Anuncios visibles en nuestras oficinas</li>
              <li>En nuestro sitio web</li>
              <li>Se lo haremos llegar al último correo electrónico que nos haya proporcionado</li>
            </ul>

            <div className="bg-notaria-primary text-white p-6 rounded-lg mt-8">
              <h3 className="text-xl font-bold mb-3">Fecha de última actualización</h3>
              <p className="mb-0">Este aviso de privacidad fue actualizado por última vez el 02 de Abril de 2026.</p>
            </div>

            <div className="mt-8 text-center">
              <Button
                onClick={handleWhatsAppContact}
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-4 text-lg inline-flex items-center gap-3"
              >
                <MessageCircle className="w-6 h-6" />
                ¿Tienes dudas? Contáctanos por WhatsApp
              </Button>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default AvisoPrivacidad;
